import React, {Fragment} from "react";
import ListView from "../../../components/ContentDisplay/ListView";
import DeleteModal from "../../../components/Modal/DeleteModal";
import EventRuleModal from "../eventRuleModal";
import {ACTIONS_LIST, LIST_HEADERS, PERMS_FOR_ACTIONS} from "./constants";
import {useEventRulesTableActions} from "./useEventRulesTableActions";
import {useEventRulesTableData} from "./useEventRulesTableData";
import EventRuleCard from "./eventRuleCard";
import EventTypesCell from "./EventTypesCell";

const EventRulesTable = () => {
  const {fetchAfterDelete, paginationConfig, eventRuleList, eventRuleTotalCount} =
    useEventRulesTableData();
  const {
    closeDeleteModal,
    closeEditModal,
    handleActionSelection,
    handleDelete,
    isDeleteModalOpen,
    isEditModalOpen,
    selectedRow,
  } = useEventRulesTableActions(fetchAfterDelete);

  return (
    <Fragment>
      {isEditModalOpen && (
        <EventRuleModal
          data={selectedRow}
          onCancel={closeEditModal}
          open={isEditModalOpen}
        />
      )}
      {isDeleteModalOpen && (
        <DeleteModal
          header={"Delete Event Rule"}
          modalBody={"Are you sure you want to delete this event rule ?"}
          onClose={closeDeleteModal}
          onDelete={handleDelete}
          open={isDeleteModalOpen}
        />
      )}
      <div className="table-container">
        <ListView
          actionsList={ACTIONS_LIST}
          cardContent={EventRuleCard}
          customRenderComponent={EventTypesCell}
          customRenderKeys={["event_types"]}
          listItems={eventRuleList}
          listHeaders={LIST_HEADERS}
          onSelectAction={handleActionSelection}
          permsForActions={PERMS_FOR_ACTIONS}
          totalCount={eventRuleTotalCount}
          withActions
          withPagination={paginationConfig}
        />
      </div>
    </Fragment>
  );
};

export default EventRulesTable;
